import React, {useState} from 'react';
import {AiOutlineClose} from 'react-icons/ai';

function CloseButton( {handleClose, id} ) {
    return(<div className = "close-button">
        <button onClick = {() => handleClose(id)} ><AiOutlineClose/></button>
        
        </div>);
}
export default CloseButton;